import type React from 'react';

import LazyIllustration from '@helsenorge/designsystem-react/components/LazyIllustration';
import PromoPanel from '@helsenorge/designsystem-react/components/PromoPanel';

interface FastlegePanelProps {
  title: string;
  description: string;
  link: string;
}

const FastlegePanel: React.FC<FastlegePanelProps> = props => {
  return (
    <PromoPanel
      color="cherry"
      href={props.link}
      title={props.title}
      illustration={<LazyIllustration illustrationName={'Doctor'} color="cherry" />}
    >
      {props.description}
    </PromoPanel>
  );
};

export default FastlegePanel;
